export class UpdateTagEditorValidation {
  static readonly type = '[TagEditorValidation] Update Tag Editor Validation'

  constructor(
    public readonly hasTags: boolean,
    public readonly isValid: boolean,
  ) {}
}
